import { Link } from "react-router-dom"
import { QuestsModel } from "../../../../Models/Quests/Quests.Model"

import "./WorkflowsRouterAndBrainButtons.scss"
import { BrainsModel } from "../../../../Models/Brains/Brains.Model"
import { Spinner } from "@swivl-mono/ui"
import { useMemo } from "react"


export function WorkflowsRouterAndBrainButtons() {
    const { router } = QuestsModel.useState((s) => s)
    const { brains } = BrainsModel.useState((s) => s)

    const globalBrain:any = useMemo(() => {
        if (brains) {
            const slug = BrainsModel.getGlobalBrainSlug()
            return brains.find((b) => b.slug === slug)
        }
    }, [brains])

    let brainButton = (globalBrain) ? <Link to={`brain/${globalBrain?.slug}`}>🧠 Global Brain</Link> :<Spinner/>
    

    return <div className="WorkflowsRouterAndBrainButtons">
    {brainButton}
    {router ? <Link to={`quest/${router.slug}`}>🔀 Router</Link> : <Spinner />}</div>

}